import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "./chartTemplate";
// import {scale} from 'd3'
import * as d3 from "d3";

 //#### Bar Chart

    // Create a bar chart and use the given css selector as anchor. You can also specify
    // an optional chart group for this chart to be scoped within. When a chart belongs
    // to a specific group then any interaction with such chart will only trigger redraw
 // on other charts within the same chart group.
const dealChartFunc = (divRef, ndx) => {
  
  // wrapping x-ticks lable texts

  function wrap(text, width) {
    text.each(function () {
      var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", 0)
          .attr("y", y)
          .attr("dy", dy + "em");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", 0)
            .attr("y", y)
            .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .text(word);
        }
      }
    });
  }
  //const dimension = ndx.dimension((d) => d.valueCategorized);
    const dimension = ndx.dimension((d) => Math.round(d.ticketSize / 1000));
  const dealCountGrp = dimension.group().reduceCount();

  
  const dealSizeChart = dc.barChart(divRef);
  dealSizeChart
    .width(400) 
    .height(55)
    .margins({ top: 0, right: 40, bottom: 35, left: 15 })
    .dimension(dimension)
    .group(dealCountGrp)
    .centerBar(true)
    .gap(1)
    .x(d3.scaleLinear().domain([1, 1000]))
    .xUnits(dc.units.integers)
    .elasticY(true)
    // .xAxisLabel("Value in Dollars(000')")
    .brushOn(true)
    .transitionDuration(0)
    // .round(d3.timeMonth.round)
    .alwaysUseRounding(true);
  
  dealSizeChart.yAxis().ticks(0);
  dealSizeChart.xAxis().ticks(6);
  return dealSizeChart;
};

export const DealSizeChart = (props) => (
  <ChartTemplate
    chartFunction={dealChartFunc}
        title="Investment Opportunities Ticket Sizes (0-1000)" id="dealSizetwo"
  />
);
